export default __webpack_public_path__ + "static/pricing-bg-eff2761b5dca8f449492406f0397b105.png";